export default __webpack_public_path__ + "static/welcome-newreg-58a607490e82a04d52192652ee88d2f5.webp";